import { DayOfWeek, Dropdown, IDropdownOption } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as ComponentFunctions from './DaySelectorFunctions';

export interface IProps {
  // single-select mode
  selectedDay?: DayOfWeek | undefined;
  onDaySelectionChanged?: (selectedDays: DayOfWeek) => void;
  // multi-select mode
  multiSelect?: boolean;
  selectedDays?: DayOfWeek[];
  onMultiDaySelectionChanged?: (days: DayOfWeek[]) => void;
}

export const DaySelectorComponent = (props: IProps) => {
  const [t] = useTranslation();
  const [selectedDay, setSelectedDay] = useState<DayOfWeek>();
  const [selectedMultiDays, setSelectedMultiDays] = useState<DayOfWeek[]>([]);
  const [selectedDaysErrorMessage, setSelectedDaysErrorMessage] =
    useState<string>();

  useEffect(() => {
    if (props.selectedDay !== undefined) {
      setSelectedDay(props.selectedDay);
    }
  }, [props.selectedDay]);

  useEffect(() => {
    if (props.selectedDays) {
      setSelectedMultiDays(props.selectedDays);
    }
  }, [props.selectedDays]);

  const onChangeDay = (
    _event: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: IDropdownOption | undefined,
    index?: number | undefined
  ) => {
    if (option) {
      setSelectedDay(option.key as DayOfWeek);
      props.onDaySelectionChanged && props.onDaySelectionChanged(option.key as DayOfWeek);
    }
  };

  const onChangeMultiDay = (
    _event: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: IDropdownOption | undefined
  ) => {
    if (option) {
      const day = option.key as DayOfWeek;
      const updated = option.selected
        ? [...selectedMultiDays, day]
        : selectedMultiDays.filter((d) => d !== day);
      setSelectedMultiDays(updated);
      props.onMultiDaySelectionChanged && props.onMultiDaySelectionChanged(updated);
    }
  };

  const validateDays = () => {
    const empty = props.multiSelect
      ? selectedMultiDays.length === 0
      : !selectedDay;
    setSelectedDaysErrorMessage(empty ? t('daySelector.validationRequired') : undefined);
  };

  if (props.multiSelect) {
    return (
      <div>
        <Dropdown
          label={t('daySelector.labelMulti')}
          placeholder={t('daySelector.placeholderMulti')}
          multiSelect
          options={ComponentFunctions.daysOptions}
          selectedKeys={selectedMultiDays.map((d) => d.toString())}
          onChange={onChangeMultiDay}
          errorMessage={selectedDaysErrorMessage}
          onBlur={validateDays}
        />
      </div>
    );
  }

  return (
    <div>
      <Dropdown
        label={t('daySelector.label')}
        placeholder={t('daySelector.placeholder')}
        options={ComponentFunctions.daysOptions}
        selectedKey={selectedDay?.toString()}
        onChange={onChangeDay}
        errorMessage={selectedDaysErrorMessage}
        onBlur={validateDays}
      />
    </div>
  );
};
